var _style, _style2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoop2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: 134,
    height: 40,
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  text {\n    text-anchor: middle; font-size: 20px; opacity: 0;\n  }\n")), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "67px 20px",
      transform: "scale(1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(67,20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-47.42px 2.755px",
      animation: "1s linear -0.612857s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.46 4.56L1.46-7.74L1.46-7.74Q1.46-8.46 1.36-9.88L1.36-9.88L2.84-10.08L3.02-9L3.02-9Q3.42-9.34 3.85-9.61L3.85-9.61L3.85-9.61Q4.28-9.88 4.79-10.07L4.79-10.07L4.79-10.07Q5.30-10.26 5.88-10.26L5.88-10.26L5.88-10.26Q6.70-10.26 7.43-9.98L7.43-9.98L7.43-9.98Q8.16-9.70 8.71-9.08L8.71-9.08L8.71-9.08Q9.26-8.46 9.58-7.47L9.58-7.47L9.58-7.47Q9.90-6.48 9.90-5.04L9.90-5.04L9.90-5.04Q9.90-3.58 9.47-2.57L9.47-2.57L9.47-2.57Q9.04-1.56 8.35-0.93L8.35-0.93L8.35-0.93Q7.66-0.30 6.79-0.02L6.79-0.02L6.79-0.02Q5.92 0.26 5.02 0.26L5.02 0.26L5.02 0.26Q4.06 0.24 3.06 0.02L3.06 0.02L3.06 4.36L1.46 4.56zM5.02-1.14L5.02-1.14L5.02-1.14Q5.86-1.14 6.46-1.44L6.46-1.44L6.46-1.44Q7.06-1.74 7.45-2.27L7.45-2.27L7.45-2.27Q7.84-2.80 8.02-3.49L8.02-3.49L8.02-3.49Q8.20-4.18 8.20-4.96L8.20-4.96L8.20-4.96Q8.20-5.66 8.07-6.36L8.07-6.36L8.07-6.36Q7.94-7.06 7.65-7.61L7.65-7.61L7.65-7.61Q7.36-8.16 6.88-8.51L6.88-8.51L6.88-8.51Q6.40-8.86 5.70-8.86L5.70-8.86L5.70-8.86Q5.18-8.86 4.72-8.67L4.72-8.67L4.72-8.67Q4.26-8.48 3.85-8.21L3.85-8.21L3.85-8.21Q3.44-7.94 3.06-7.60L3.06-7.60L3.06-1.46L3.06-1.46Q3.28-1.38 3.55-1.31L3.55-1.31L3.55-1.31Q3.82-1.24 4.19-1.19L4.19-1.19L4.19-1.19Q4.56-1.14 5.02-1.14",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-40.01px -1.975px",
      animation: "1s linear -0.565714s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.24 0L12.24-14.98L13.84-15.16L13.84 0L12.24 0",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-32.64px 0.605px",
      animation: "1s linear -0.518571s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.86-1.58L24.16-0.24L24.16-0.24Q23.70-0.10 23.21 0L23.21 0L23.21 0Q22.72 0.10 22.13 0.18L22.13 0.18L22.13 0.18Q21.54 0.26 20.90 0.26L20.90 0.26L20.90 0.26Q19.90 0.26 19.04-0.02L19.04-0.02L19.04-0.02Q18.18-0.30 17.54-0.92L17.54-0.92L17.54-0.92Q16.90-1.54 16.53-2.53L16.53-2.53L16.53-2.53Q16.16-3.52 16.16-4.96L16.16-4.96L16.16-4.96Q16.16-6.26 16.52-7.25L16.52-7.25L16.52-7.25Q16.88-8.24 17.51-8.91L17.51-8.91L17.51-8.91Q18.14-9.58 18.99-9.92L18.99-9.92L18.99-9.92Q19.84-10.26 20.84-10.26L20.84-10.26L20.84-10.26Q21.82-10.26 22.54-9.88L22.54-9.88L22.54-9.88Q23.26-9.50 23.73-8.85L23.73-8.85L23.73-8.85Q24.20-8.20 24.43-7.33L24.43-7.33L24.43-7.33Q24.66-6.46 24.66-5.50L24.66-5.50L24.36-4.62L17.90-4.62L17.90-4.62Q17.90-4 18.06-3.38L18.06-3.38L18.06-3.38Q18.22-2.76 18.61-2.26L18.61-2.26L18.61-2.26Q19-1.76 19.63-1.45L19.63-1.45L19.63-1.45Q20.26-1.14 21.20-1.14L21.20-1.14L21.20-1.14Q21.80-1.14 22.30-1.21L22.30-1.21L22.30-1.21Q22.80-1.28 23.17-1.37L23.17-1.37L23.17-1.37Q23.54-1.46 23.86-1.58L23.86-1.58zM17.96-5.90L23-5.90L23-5.90Q23-6.04 22.94-6.52L22.94-6.52L22.94-6.52Q22.88-7 22.66-7.52L22.66-7.52L22.66-7.52Q22.44-8.04 21.98-8.45L21.98-8.45L21.98-8.45Q21.52-8.86 20.76-8.86L20.76-8.86L20.76-8.86Q19.92-8.86 19.38-8.51L19.38-8.51L19.38-8.51Q18.84-8.16 18.52-7.68L18.52-7.68L18.52-7.68Q18.20-7.20 18.08-6.70L18.08-6.70L18.08-6.70Q17.96-6.20 17.96-5.90L17.96-5.90",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-22.97px 0.605px",
      animation: "1s linear -0.471429s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.44-2.34L32.44-4.62L32.44-4.62Q32.04-4.60 31.68-4.58L31.68-4.58L31.68-4.58Q31.32-4.56 30.97-4.53L30.97-4.53L30.97-4.53Q30.62-4.50 30.34-4.46L30.34-4.46L30.34-4.46Q28.90-4.28 28.30-3.83L28.30-3.83L28.30-3.83Q27.70-3.38 27.70-2.54L27.70-2.54L27.70-2.54Q27.70-1.84 28.13-1.49L28.13-1.49L28.13-1.49Q28.56-1.14 29.26-1.14L29.26-1.14L29.26-1.14Q30.22-1.14 30.97-1.47L30.97-1.47L30.97-1.47Q31.72-1.80 32.44-2.34L32.44-2.34zM32.62 0.16L32.42-0.94L32.42-0.94Q31.48-0.40 30.67-0.07L30.67-0.07L30.67-0.07Q29.86 0.26 28.92 0.26L28.92 0.26L28.92 0.26Q27.58 0.26 26.79-0.39L26.79-0.39L26.79-0.39Q26.00-1.04 26.00-2.54L26.00-2.54L26.00-2.54Q26.00-3.32 26.40-3.90L26.40-3.90L26.40-3.90Q26.80-4.48 27.45-4.87L27.45-4.87L27.45-4.87Q28.10-5.26 28.92-5.48L28.92-5.48L28.92-5.48Q29.74-5.70 30.60-5.76L30.60-5.76L30.60-5.76Q30.96-5.80 31.54-5.83L31.54-5.83L31.54-5.83Q32.12-5.86 32.44-5.88L32.44-5.88L32.44-5.88Q32.44-6.58 32.40-7.13L32.40-7.13L32.40-7.13Q32.36-7.68 32.16-8.07L32.16-8.07L32.16-8.07Q31.96-8.46 31.57-8.66L31.57-8.66L31.57-8.66Q31.18-8.86 30.46-8.86L30.46-8.86L30.46-8.86Q29.88-8.86 29.34-8.79L29.34-8.79L29.34-8.79Q28.80-8.72 28.38-8.64L28.38-8.64L28.38-8.64Q27.88-8.54 27.46-8.42L27.46-8.42L27.14-9.80L27.14-9.80Q27.64-9.92 28.22-10.02L28.22-10.02L28.22-10.02Q28.72-10.12 29.38-10.19L29.38-10.19L29.38-10.19Q30.04-10.26 30.80-10.26L30.80-10.26L30.80-10.26Q31.82-10.26 32.45-9.96L32.45-9.96L32.45-9.96Q33.08-9.66 33.43-9.15L33.43-9.15L33.43-9.15Q33.78-8.64 33.91-7.99L33.91-7.99L33.91-7.99Q34.04-7.34 34.04-6.62L34.04-6.62L34.04-1.82L34.04-1.82Q34.04-1.54 34.05-1.23L34.05-1.23L34.05-1.23Q34.06-0.92 34.09-0.62L34.09-0.62L34.09-0.62Q34.12-0.32 34.16 0L34.16 0L32.62 0.16",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-13.41px 0.605px",
      animation: "1s linear -0.424286s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.58-9.84L42.30-8.42L42.30-8.42Q41.46-8.68 40.81-8.77L40.81-8.77L40.81-8.77Q40.16-8.86 39.62-8.86L39.62-8.86L39.62-8.86Q38.92-8.86 38.45-8.52L38.45-8.52L38.45-8.52Q37.98-8.18 37.98-7.64L37.98-7.64L37.98-7.64Q38-7.16 38.40-6.82L38.40-6.82L38.40-6.82Q38.80-6.48 39.33-6.21L39.33-6.21L39.33-6.21Q39.86-5.94 40.51-5.62L40.51-5.62L40.51-5.62Q41.16-5.30 41.73-4.90L41.73-4.90L41.73-4.90Q42.30-4.50 42.66-3.94L42.66-3.94L42.66-3.94Q43.02-3.38 43.04-2.60L43.04-2.60L43.04-2.60Q43.02-1.76 42.67-1.21L42.67-1.21L42.67-1.21Q42.32-0.66 41.77-0.33L41.77-0.33L41.77-0.33Q41.22 0 40.58 0.13L40.58 0.13L40.58 0.13Q39.94 0.26 39.38 0.26L39.38 0.26L39.38 0.26Q38.66 0.26 37.89 0.18L37.89 0.18L37.89 0.18Q37.12 0.10 36.24-0.16L36.24-0.16L36.54-1.60L36.54-1.60Q37.44-1.36 38.18-1.25L38.18-1.25L38.18-1.25Q38.92-1.14 39.40-1.14L39.40-1.14L39.40-1.14Q39.76-1.14 40.11-1.22L40.11-1.22L40.11-1.22Q40.46-1.30 40.74-1.45L40.74-1.45L40.74-1.45Q41.02-1.60 41.19-1.84L41.19-1.84L41.19-1.84Q41.36-2.08 41.36-2.38L41.36-2.38L41.36-2.38Q41.34-2.94 40.98-3.33L40.98-3.33L40.98-3.33Q40.62-3.72 40.05-4.03L40.05-4.03L40.05-4.03Q39.48-4.34 38.83-4.65L38.83-4.65L38.83-4.65Q38.18-4.96 37.61-5.37L37.61-5.37L37.61-5.37Q37.04-5.78 36.66-6.35L36.66-6.35L36.66-6.35Q36.28-6.92 36.28-7.76L36.28-7.76L36.28-7.76Q36.28-8.36 36.59-8.83L36.59-8.83L36.59-8.83Q36.90-9.30 37.39-9.61L37.39-9.61L37.39-9.61Q37.88-9.92 38.47-10.09L38.47-10.09L38.47-10.09Q39.06-10.26 39.62-10.26L39.62-10.26L39.62-10.26Q40.20-10.26 40.92-10.17L40.92-10.17L40.92-10.17Q41.64-10.08 42.58-9.84L42.58-9.84",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "-4.15999px 0.605px",
      animation: "1s linear -0.377143s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.34-1.58L52.64-0.24L52.64-0.24Q52.18-0.10 51.69 0L51.69 0L51.69 0Q51.20 0.10 50.61 0.18L50.61 0.18L50.61 0.18Q50.02 0.26 49.38 0.26L49.38 0.26L49.38 0.26Q48.38 0.26 47.52-0.02L47.52-0.02L47.52-0.02Q46.66-0.30 46.02-0.92L46.02-0.92L46.02-0.92Q45.38-1.54 45.01-2.53L45.01-2.53L45.01-2.53Q44.64-3.52 44.64-4.96L44.64-4.96L44.64-4.96Q44.64-6.26 45.00-7.25L45.00-7.25L45.00-7.25Q45.36-8.24 45.99-8.91L45.99-8.91L45.99-8.91Q46.62-9.58 47.47-9.92L47.47-9.92L47.47-9.92Q48.32-10.26 49.32-10.26L49.32-10.26L49.32-10.26Q50.30-10.26 51.02-9.88L51.02-9.88L51.02-9.88Q51.74-9.50 52.21-8.85L52.21-8.85L52.21-8.85Q52.68-8.20 52.91-7.33L52.91-7.33L52.91-7.33Q53.14-6.46 53.14-5.50L53.14-5.50L52.84-4.62L46.38-4.62L46.38-4.62Q46.38-4 46.54-3.38L46.54-3.38L46.54-3.38Q46.70-2.76 47.09-2.26L47.09-2.26L47.09-2.26Q47.48-1.76 48.11-1.45L48.11-1.45L48.11-1.45Q48.74-1.14 49.68-1.14L49.68-1.14L49.68-1.14Q50.28-1.14 50.78-1.21L50.78-1.21L50.78-1.21Q51.28-1.28 51.65-1.37L51.65-1.37L51.65-1.37Q52.02-1.46 52.34-1.58L52.34-1.58zM46.44-5.90L51.48-5.90L51.48-5.90Q51.48-6.04 51.42-6.52L51.42-6.52L51.42-6.52Q51.36-7 51.14-7.52L51.14-7.52L51.14-7.52Q50.92-8.04 50.46-8.45L50.46-8.45L50.46-8.45Q50.00-8.86 49.24-8.86L49.24-8.86L49.24-8.86Q48.40-8.86 47.86-8.51L47.86-8.51L47.86-8.51Q47.32-8.16 47.00-7.68L47.00-7.68L47.00-7.68Q46.68-7.20 46.56-6.70L46.56-6.70L46.56-6.70Q46.44-6.20 46.44-5.90L46.44-5.90",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "12.96px 0.575px",
      animation: "1s linear -0.33s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.54 0L58.82-10.06L60.50-10.06L61.68-5.52L61.68-5.52Q61.84-4.94 61.97-4.29L61.97-4.29L61.97-4.29Q62.10-3.64 62.22-3.08L62.22-3.08L62.22-3.08Q62.34-2.42 62.48-1.78L62.48-1.78L62.50-1.78L62.50-1.78Q62.64-2.42 62.82-3.08L62.82-3.08L62.82-3.08Q62.98-3.64 63.16-4.29L63.16-4.29L63.16-4.29Q63.34-4.94 63.52-5.52L63.52-5.52L64.94-10.06L67.08-10.06L68.22-5.52L68.22-5.52Q68.36-4.94 68.51-4.29L68.51-4.29L68.51-4.29Q68.66-3.64 68.76-3.08L68.76-3.08L68.76-3.08Q68.88-2.42 69.00-1.78L69.00-1.78L69.02-1.78L69.02-1.78Q69.20-2.44 69.40-3.10L69.40-3.10L69.40-3.10Q69.56-3.66 69.76-4.31L69.76-4.31L69.76-4.31Q69.96-4.96 70.14-5.52L70.14-5.52L71.54-10.06L73.20-10.06L69.90 0L68.12 0L66.68-5.52L66.68-5.52Q66.48-6.28 66.35-6.89L66.35-6.89L66.35-6.89Q66.22-7.50 66.12-7.92L66.12-7.92L66.12-7.92Q66.02-8.42 65.94-8.80L65.94-8.80L65.90-8.80L65.90-8.80Q65.82-8.42 65.70-7.92L65.70-7.92L65.70-7.92Q65.60-7.50 65.42-6.89L65.42-6.89L65.42-6.89Q65.24-6.28 65.02-5.52L65.02-5.52L63.32 0L61.54 0",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "24.99px 0.605px",
      animation: "1s linear -0.282857s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.40-2.34L80.40-4.62L80.40-4.62Q80.00-4.60 79.64-4.58L79.64-4.58L79.64-4.58Q79.28-4.56 78.93-4.53L78.93-4.53L78.93-4.53Q78.58-4.50 78.30-4.46L78.30-4.46L78.30-4.46Q76.86-4.28 76.26-3.83L76.26-3.83L76.26-3.83Q75.66-3.38 75.66-2.54L75.66-2.54L75.66-2.54Q75.66-1.84 76.09-1.49L76.09-1.49L76.09-1.49Q76.52-1.14 77.22-1.14L77.22-1.14L77.22-1.14Q78.18-1.14 78.93-1.47L78.93-1.47L78.93-1.47Q79.68-1.80 80.40-2.34L80.40-2.34zM80.58 0.16L80.38-0.94L80.38-0.94Q79.44-0.40 78.63-0.07L78.63-0.07L78.63-0.07Q77.82 0.26 76.88 0.26L76.88 0.26L76.88 0.26Q75.54 0.26 74.75-0.39L74.75-0.39L74.75-0.39Q73.96-1.04 73.96-2.54L73.96-2.54L73.96-2.54Q73.96-3.32 74.36-3.90L74.36-3.90L74.36-3.90Q74.76-4.48 75.41-4.87L75.41-4.87L75.41-4.87Q76.06-5.26 76.88-5.48L76.88-5.48L76.88-5.48Q77.70-5.70 78.56-5.76L78.56-5.76L78.56-5.76Q78.92-5.80 79.50-5.83L79.50-5.83L79.50-5.83Q80.08-5.86 80.40-5.88L80.40-5.88L80.40-5.88Q80.40-6.58 80.36-7.13L80.36-7.13L80.36-7.13Q80.32-7.68 80.12-8.07L80.12-8.07L80.12-8.07Q79.92-8.46 79.53-8.66L79.53-8.66L79.53-8.66Q79.14-8.86 78.42-8.86L78.42-8.86L78.42-8.86Q77.84-8.86 77.30-8.79L77.30-8.79L77.30-8.79Q76.76-8.72 76.34-8.64L76.34-8.64L76.34-8.64Q75.84-8.54 75.42-8.42L75.42-8.42L75.10-9.80L75.10-9.80Q75.60-9.92 76.18-10.02L76.18-10.02L76.18-10.02Q76.68-10.12 77.34-10.19L77.34-10.19L77.34-10.19Q78.00-10.26 78.76-10.26L78.76-10.26L78.76-10.26Q79.78-10.26 80.41-9.96L80.41-9.96L80.41-9.96Q81.04-9.66 81.39-9.15L81.39-9.15L81.39-9.15Q81.74-8.64 81.87-7.99L81.87-7.99L81.87-7.99Q82.00-7.34 82.00-6.62L82.00-6.62L82.00-1.82L82.00-1.82Q82.00-1.54 82.01-1.23L82.01-1.23L82.01-1.23Q82.02-0.92 82.05-0.62L82.05-0.62L82.05-0.62Q82.08-0.32 82.12 0L82.12 0L80.58 0.16",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "32.57px 0.475px",
      animation: "1s linear -0.235714s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.82 0L84.82-10.08L86.42-10.26L86.42 0L84.82 0",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "32.62px -7.335px",
      animation: "1s linear -0.188571s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.56-12.94L84.56-12.94L84.56-12.94Q84.56-13.40 84.87-13.71L84.87-13.71L84.87-13.71Q85.18-14.02 85.64-14.02L85.64-14.02L85.64-14.02Q86.12-14.02 86.45-13.71L86.45-13.71L86.45-13.71Q86.78-13.40 86.78-12.94L86.78-12.94L86.78-12.94Q86.78-12.48 86.45-12.17L86.45-12.17L86.45-12.17Q86.12-11.86 85.64-11.86L85.64-11.86L85.64-11.86Q85.18-11.86 84.87-12.17L84.87-12.17L84.87-12.17Q84.56-12.48 84.56-12.94",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "38.44px -0.795px",
      animation: "1s linear -0.141429s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.04-12.86L91.64-13.06L91.64-10.06L94.54-10.06L94.54-8.76L91.64-8.76L91.64-3.42L91.64-3.42Q91.64-2.76 91.67-2.32L91.67-2.32L91.67-2.32Q91.70-1.88 91.80-1.62L91.80-1.62L91.80-1.62Q91.90-1.36 92.08-1.25L92.08-1.25L92.08-1.25Q92.26-1.14 92.54-1.14L92.54-1.14L92.54-1.14Q93.30-1.16 94.30-1.70L94.30-1.70L94.78-0.48L94.78-0.48Q94.12-0.04 93.55 0.11L93.55 0.11L93.55 0.11Q92.98 0.26 92.42 0.26L92.42 0.26L92.42 0.26Q91.10 0.26 90.57-0.49L90.57-0.49L90.57-0.49Q90.04-1.24 90.04-2.98L90.04-2.98L90.04-8.76L88.20-8.76L88.20-10.06L90.04-10.06L90.04-12.86",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "44.32px 4.425px",
      animation: "1s linear -0.0942857s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.16-1.18L96.16-1.18L96.16-1.18Q96.16-1.66 96.50-2.01L96.50-2.01L96.50-2.01Q96.84-2.36 97.34-2.36L97.34-2.36L97.34-2.36Q97.86-2.36 98.22-2.01L98.22-2.01L98.22-2.01Q98.58-1.66 98.58-1.18L98.58-1.18L98.58-1.18Q98.58-0.68 98.22-0.34L98.22-0.34L98.22-0.34Q97.86 0 97.34 0L97.34 0L97.34 0Q96.84 0 96.50-0.34L96.50-0.34L96.50-0.34Q96.16-0.68 96.16-1.18",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "48.76px 4.425px",
      animation: "1s linear -0.0471429s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.60-1.18L100.60-1.18L100.60-1.18Q100.60-1.66 100.94-2.01L100.94-2.01L100.94-2.01Q101.28-2.36 101.78-2.36L101.78-2.36L101.78-2.36Q102.30-2.36 102.66-2.01L102.66-2.01L102.66-2.01Q103.02-1.66 103.02-1.18L103.02-1.18L103.02-1.18Q103.02-0.68 102.66-0.34L102.66-0.34L102.66-0.34Q102.30 0 101.78 0L101.78 0L101.78 0Q101.28 0 100.94-0.34L100.94-0.34L100.94-0.34Q100.60-0.68 100.60-1.18",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 1,
      transformOrigin: "53.2px 4.425px",
      animation: "1s linear 0s infinite normal forwards running fade-c91cc683-42f1-4294-8411-04e87c8e6503"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.04-1.18L105.04-1.18L105.04-1.18Q105.04-1.66 105.38-2.01L105.38-2.01L105.38-2.01Q105.72-2.36 106.22-2.36L106.22-2.36L106.22-2.36Q106.74-2.36 107.10-2.01L107.10-2.01L107.10-2.01Q107.46-1.66 107.46-1.18L107.46-1.18L107.46-1.18Q107.46-0.68 107.10-0.34L107.10-0.34L107.10-0.34Q106.74 0 106.22 0L106.22 0L106.22 0Q105.72 0 105.38-0.34L105.38-0.34L105.38-0.34Q105.04-0.68 105.04-1.18",
    fill: "#030659",
    stroke: "none",
    strokeWidth: "none",
    transform: "translate(-53.04998779296875,5.605000414167129)",
    style: {
      fill: "rgb(3, 6, 89)"
    }
  }))))), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    id: "fade-c91cc683-42f1-4294-8411-04e87c8e6503",
    "data-anikit": ""
  }, "@keyframes fade-c91cc683-42f1-4294-8411-04e87c8e6503\n{\n  0% {\n    animation-timing-function: cubic-bezier(0.2057,0.573,0.3723,0.9184);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop2);
export default __webpack_public_path__ + "static/media/loop2.d913f0de946ed2b8d5754dd22d66d7ed.svg";
export { ForwardRef as ReactComponent };